import { useTranslation } from 'react-i18next';

export default function Features() {
  const { t } = useTranslation('common');

  return (
    <section id="features" className="py-24 px-6 bg-white dark:bg-gray-900">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start mb-16">
          <h2 className="text-6xl font-black text-gray-900 dark:text-gray-100 leading-tight">
            {t('features.title')}<br />{t('features.titleLine2')}
          </h2>
          <p className="text-gray-600 dark:text-gray-400 text-lg max-w-md mt-4 md:mt-8">
            {t('features.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-10 gap-5">
          <div className="md:col-span-4 bg-gradient-to-br from-purple-500 to-pink-500 rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all hover:-translate-y-2 cursor-pointer">
            <div className="mb-6">
              <img 
                src="https://public.readdy.ai/ai/img_res/151fcb65f0c73d862e8ff00562def35d.jpg"
                alt="Voice Chat"
                className="w-full h-64 object-cover object-top rounded-2xl"
              />
            </div>
            <h3 className="text-3xl font-bold text-white mb-3">{t('features.voiceChat')}</h3>
            <p className="text-white/90 text-base leading-relaxed">
              {t('features.voiceChatDesc')}
            </p>
          </div>

          <div className="md:col-span-3 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all hover:-translate-y-2 cursor-pointer">
            <h3 className="text-2xl font-bold text-white mb-4">{t('features.liveVideo')}</h3>
            <div className="mb-4">
              <img 
                src="https://readdy.ai/api/search-image?query=video%20call%20interface%20with%20multiple%20participants%20in%20grid%20layout%2C%20blue%20gradient%20background%2C%20modern%20digital%20illustration%20showing%20live%20streaming%20and%20video%20chat%2C%20floating%20emoji%20reactions%2C%20clean%20contemporary%20design%20for%20social%20application&width=500&height=400&seq=feature-video-001&orientation=portrait"
                alt="Video Chat"
                className="w-full h-56 object-cover object-top rounded-2xl"
              />
            </div>
            <p className="text-white/90 text-sm leading-relaxed">
              {t('features.liveVideoDesc')}
            </p>
          </div>

          <div className="md:col-span-3 bg-gradient-to-br from-orange-500 to-yellow-500 rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all hover:-translate-y-2 cursor-pointer relative">
            <div className="absolute top-6 right-6 bg-white/30 backdrop-blur-sm px-3 py-1 rounded-full">
              <span className="text-white text-xs font-bold">{t('features.miniGamesTag')}</span>
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">{t('features.miniGames')}</h3>
            <div className="mb-4">
              <img 
                src="https://readdy.ai/api/search-image?query=playful%20mini%20games%20interface%20with%20game%20controller%20and%20trophy%20icons%2C%20orange%20to%20yellow%20gradient%20background%2C%20colorful%20digital%20illustration%20showing%20casual%20gaming%20elements%2C%20fun%20and%20energetic%20design%20with%20vibrant%20colors%20perfect%20for%20social%20gaming%20app&width=500&height=400&seq=feature-games-001&orientation=portrait"
                alt="Mini Games"
                className="w-full h-56 object-cover object-top rounded-2xl"
              />
            </div>
            <p className="text-white/90 text-sm leading-relaxed">
              {t('features.miniGamesDesc')}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-5">
          <div className="bg-gradient-to-br from-teal-500 to-green-500 rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all hover:-translate-y-2 cursor-pointer">
            <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-group-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-3">{t('features.familySpaces')}</h3>
            <p className="text-white/90 text-base leading-relaxed">
              {t('features.familySpacesDesc')}
            </p>
          </div>

          <div className="bg-gradient-to-br from-red-500 to-pink-500 rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all hover:-translate-y-2 cursor-pointer">
            <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-message-3-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-3">{t('features.instantMessaging')}</h3>
            <p className="text-white/90 text-base leading-relaxed">
              {t('features.instantMessagingDesc')}
            </p>
          </div>

          <div className="bg-gradient-to-br from-indigo-500 to-purple-500 rounded-3xl p-8 shadow-xl hover:shadow-2xl transition-all hover:-translate-y-2 cursor-pointer">
            <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-gift-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-3">{t('features.virtualGifts')}</h3>
            <p className="text-white/90 text-base leading-relaxed">
              {t('features.virtualGiftsDesc')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
